// Local-day → exact UTC instant helpers.
//
// A "YYYY-MM-DD" from a <input type="date"> is converted to the exact instant of
// the viewer's LOCAL start/end of that day. Everything that filters or prints by
// date (the lab orders list, its print/export, the reports bulk print) uses this
// one conversion, so the visible list and the printed set can never disagree by a
// day across timezones. Empty input → empty output (so the query param is omitted).
export const dayStartISO = (ymd) => {
    if (!ymd) return '';
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d, 0, 0, 0, 0).toISOString();
};

export const dayEndISO = (ymd) => {
    if (!ymd) return '';
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d, 23, 59, 59, 999).toISOString();
};

// "YYYY-MM-DD" for the viewer's local today (for "today" print/export flows).
export const localTodayYMD = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};
